import React, { useState } from 'react';
import '@/assets/app/css/login.css';
import iconBear from '@/assets/app/images/icon/icon-bear.png';
import iconLoginLogo from '@/assets/app/images/icon/icon-login-logo.png';
import iconKakao from '@/assets/app/images/icon/icon-kakao.png';
import iconNaver from '@/assets/app/images/icon/icon-naver.png';
import iconGoogle from '@/assets/app/images/icon/icon-google.png';
import iconApple from '@/assets/app/images/icon/icon-apple.png';
import { getBackEndUrl, getFileSrc } from '@/shared/utils/CommonUtil';
import IntroVideo from '../main/IntroVideo';

const LoginPage: React.FC = () => {
  const [showIntro, setShowIntro] = useState<boolean>(true);
  // SNS 로그인 공통 함수
  const handleLogin = (provider: 'kakao' | 'naver' | 'google' | 'apple') => {
    // 로그인 후 돌아올 프론트엔드 URL
    const redirectUri = `${window.location.origin}/auth/callback`;

    // 백엔드에서 설정한 OAuth2 엔드포인트 기준 (Spring Security 등)
    // 예: /oauth2/authorization/kakao, /oauth2/authorization/naver ...
    const authUrl = `${getBackEndUrl()}/oauth2/authorization/${provider}`;

    window.location.href = authUrl;
  };

  if (showIntro) {
    return [<IntroVideo setShowIntro={setShowIntro} />];
  }
  return (
    <div className="login-container">
      <div className="login-content">
        {/* 로고 영역 */}
        <div className="logo-section">
          <img src={iconLoginLogo} alt="Tomtomi Logo" style={{ width: '60%' }} />
        </div>

        {/* 카카오 로그인 버튼 */}
        <img
          src={iconKakao}
          alt="Kakao"
          style={{ width: '55%', marginBottom: 30 }}
          onClick={() => handleLogin('kakao')}
        />

        {/* SNS 로그인 버튼들 */}
        <div className="sns-login-section">
          <img
            src={iconNaver}
            alt="Naver"
            className="sns-button"
            onClick={() => handleLogin('naver')}
          />
          <img
            src={iconGoogle}
            alt="Google"
            className="sns-button"
            onClick={() => handleLogin('google')}
          />
          <img
            src={iconApple}
            alt="Apple"
            className="sns-button"
            onClick={() => handleLogin('apple')}
          />
        </div>

        {/* 안내 문구 */}
        <p className="login-notice">
          문의가 있는 경우{' '}
          <strong className="underline font-semibold cursor-pointer">고객센터</strong>로 연락
          주세요.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
